export default __webpack_public_path__ + "static/Lucy-a72d14af4bbc58ee4bc4e0d14c8a5156.jpeg";